import React from 'react'
import Modal from 'react-modal'

import DetailsPanel from '../BidTracker/Panels/Details/Details'
import HistoryPanel from '../BidTracker/Panels/History/History'

import CommError from '../../Shared/Errors/Errors'

import './CreateEditBid.css'

const styling = {
    content: {
        top: '0px',
        left: '0px',
        width: '100%',
        height: '100%',
        maxWidth: 'none',
        paddingTop: '0px',
        background: 'white',
        paddingLeft: '50px',
        paddingRight: '40px'
    }
}

const CreateEditBid = (
    {
        errBid,
        errBidClear,

        curBid,
        tmpBid,
        histPage,

        isCreate,
        isOpen,
        bidCheck,
        viewOnly,
        selectPanel,
        users,
        newDateSearch,
        newUserSearch,
        loadMore,

        onAfterOpen,
        onRequestClose,
        onRequestCancel
    }) => (
    <Modal isOpen={isOpen} onAfterOpen={onAfterOpen} onRequestClose={onRequestClose} style={styling}>
        <CommError error={errBid.error} onClose={errBidClear} />

        <div className="create-edit-bid editpages productManagement">
            <h1>{isCreate ? 'Create' : viewOnly ? 'View' : 'Edit' } Bid</h1>

            <div className="form-group buttons first">
                <a className="btn bid-cancel btn-default" onClick={onRequestCancel} >Cancel</a>
                <button className="btn bid btn-primary modbrick" create={isCreate ? "true" : "false"} onClick={onRequestClose}>Submit</button>
            </div>

            <ul>
                <li className="bidview" panel="Details" onClick={selectPanel}>Details</li>
                {
                    isCreate
                        ? <li className="bidview" panel="History" disabled>Change History</li>
                        : <li className="bidview" panel="History" onClick={selectPanel}>Change History</li>
                }
            </ul>

            <div className="panelFrame" id="Details">
                <DetailsPanel isCreate={isCreate} bid={isCreate ? tmpBid : curBid.bid} bidCheck={bidCheck} />
            </div>
            <div className="panelFrame" id="History">
                <HistoryPanel page={histPage} bid={curBid} items={users} newDateSearch={newDateSearch} newUserSearch={newUserSearch} loadMore={loadMore} />
            </div>

            <div className="form-group buttons last">
                <a className="btn bid-cancel btn-default" onClick={onRequestCancel} >Cancel</a>
                <button className="btn bid btn-primary modbrick" create={isCreate ? "true" : "false"} onClick={onRequestClose}>Submit</button>
            </div>
        </div>
    </Modal>
);

// Modal.setAppElement('body');
        
export default CreateEditBid